import { axios, Response } from '..'

export interface GetTaskTagsResponse {
  taskTagId: number
  title: string
  hexadecimalColorCode: string
}

export const getAllTaskTags = (): Response<GetTaskTagsResponse[]> => {
  return axios.get(`/v1/tags`)
}
